import React from "react";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { getModelById } from "../services/modelService";
import { Context } from "../App";
import { resolveAuthorName } from "../utils/modelPreview";
import ModelMiniature from "../components/models/ModelMiniature";

export default function ViewModel() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { deconnect } = React.useContext(Context);

    const [model, setModel] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState("");

    React.useEffect(() => {
        let active = true;

        const run = async () => {
            try {
                const data = await getModelById(id);
                if (!active) return;
                setModel(data);
            } catch (e) {
                if (!active) return;
                if (e.message === "SESSION_EXPIRED") {
                    alert("Votre session a expiré. Veuillez vous reconnecter.");
                    deconnect();
                    return;
                }
                setError("Impossible de charger ce modèle.");
            } finally {
                if (active) setLoading(false);
            }
        };

        run();
        return () => {
            active = false;
        };
    }, [id, deconnect]);

    if (loading) {
        return (
            <Box sx={{ p: 4, display: "flex", justifyContent: "center" }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error || !model) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert severity="error">{error || "Modèle introuvable."}</Alert>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>{model.title}</Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 1.5 }}>
                {model.description || "Aucune description"}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Auteur: {resolveAuthorName(model.autor)} | Date: {model.updatedAt ? new Date(model.updatedAt).toLocaleString() : "-"}
            </Typography>

            <ModelMiniature model={model} fit />

            <Box sx={{ mt: 3, display: "flex", gap: 1 }}>
                <Button variant="outlined" onClick={() => navigate("/model")}>Retour</Button>
                <Button variant="contained" onClick={() => navigate(`/model/${model._id}/edit`)}>Modifier</Button>
                <Button variant="contained" color="secondary" onClick={() => navigate("/design/new", { state: { modelId: model._id } })}>
                    Créer un design depuis ce modèle
                </Button>
            </Box>
        </Box>
    );
}
